import { useStyletron } from 'baseui';
import { KIND, SIZE } from 'baseui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ENGTButton from 'components/UI/ENGTButton/ENGTButton';

import useResponsiveSize from 'shared/hooks/useResponsiveSize';
import AddIcon from 'shared/icons/AddIcon';

import { ThreeColumnRouteLinks } from 'router/links/ThreeColumnRouteLinks';

const CreateVoiceCampaignBtn = (props: { overrides?: Record<string, any> }) => {
	const [css]: [any, any] = useStyletron();
	const { t } = useTranslation(['pages']);
	const navigate = useNavigate();
	const { isSmallDesktopScreen } = useResponsiveSize();

	const { overrides = {} } = props;

	return (
		<ENGTButton
			size={SIZE.compact}
			kind={KIND.primary}
			label={t('pages:voiceCampaign.create.createButton')}
			startEnhancer={<AddIcon />}
			className={css({
				marginBottom: `${isSmallDesktopScreen ? '0rem' : '2rem'} !important`,
				...overrides,
			})}
			onClick={() => navigate(ThreeColumnRouteLinks.createVoiceCampaign)}
		/>
	);
};

CreateVoiceCampaignBtn.defaultProps = {
	overrides: {},
};

export default CreateVoiceCampaignBtn;
